<template>
  <div class="radios-action">
    <template v-if="data.hasGroups">
      <div
        v-for="(optionGroup, optionGroupIndex) in options"
        :key="optionGroupIndex"
        class="option-group">
        <h5 class="option-group-title">
          {{ optionGroup.label }}
        </h5>
        <el-radio
          v-for="(radio, optionIndex) in optionGroup.data"
          :key="optionIndex"
          v-model="selectedRadio"
          class="option"
          :label="radio"
          border>
          {{ radio.label }}
        </el-radio>
      </div>
    </template>

    <template v-else>
      <el-radio
        v-for="(radio, index) in options"
        :key="index"
        v-model="selectedRadio"
        class="option"
        :label="radio"
        border>
        {{ radio.label }}
      </el-radio>
    </template>

    <ButtonAction
      class="mt-3"
      :data="{ label: data.label }"
      :is-disabled="isValidationDisabled"
      :is-large="isLarge"
      @validate="validate" />
  </div>
</template>

<script>
import ButtonAction from "@/components/chatbot/Bubbles/actions/ButtonAction"

export default {
  name: "RadiosAction",
  components: { ButtonAction },
  props: {
    data: {
      type: Object,
      required: true
    },
    isLarge: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      options: [],
      selectedRadio: null
    }
  },
  computed: {
    isValidationDisabled() {
      return this.selectedRadio === null
    }
  },
  created() {
    this.options = JSON.parse(JSON.stringify(this.data.options))
  },
  methods: {
    validate() {
      if (!this.selectedRadio) {
        return
      }

      this.$emit("validate", this.selectedRadio.id)
    }
  }
}
</script>

<style lang="scss">
.radios-action {
  .el-radio {
    .el-radio__label {
      font-size: 14px;
      white-space: normal;
      box-decoration-break: clone;
      padding-left: 0;
    }

    .el-radio__input {
      display: none;
    }
  }

  .el-radio.is-bordered + .el-radio.is-bordered {
    margin-left: 0;
  }
}
</style>

<style lang="scss" scoped>
.radios-action {
  display: flex;
  flex-direction: column;
  align-items: flex-end;

  .option-group {
    display: flex;
    flex-direction: column;
    margin-bottom: 16px;

    &:last-of-type {
      margin-bottom: 0;
    }

    .option-group-title {
      text-align: center;
      background-color: color(paperWhite);
      padding: 10px 16px;
      border-radius: 18px;
      margin: 0 0 8px 0;
    }
  }

  .option {
    text-align: center;
    margin: 0 0 8px 0;
    min-width: 40%;
    height: auto;
    padding: 8px 18px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}
</style>
